import { gql } from 'graphql-request';

export const openCallsQuery = gql`
  query OpenCalls($page: Int!, $limit: Int!) {
    openCalls(page: $page, limit: $limit) {
      items {
        id
        name
        isAmericanStyleOpenCall
        typeId
        status
        totalApplicants
        defaultStageId
        brand {
          organizationId
          logoURL
          name
        }
        stages {
          id
          isDefault
        }
        createdAt
        closedAt
      }
      totalCount
      page
      limit
    }
  }
`;

export const openCallQuery = gql`
  query OpenCall($id: ID!) {
    openCall(id: $id) {
      id
      name
      isAmericanStyleOpenCall
      typeId
      status
      totalApplicants
      defaultStageId
      brand {
        organizationId
        logoURL
        name
      }
      stages {
        id
        isDefault
      }
      createdAt
      closedAt
    }
  }
`;
